export enum LabControllerUsePermissionEnum {
    ONLY_ME = 'ONLY_ME',
    GADGET_ADMIN = 'GADGET_ADMIN',
    EVERYONE = 'EVERYONE'
}

export enum LabControllerEditPermissionEnum {
    ONLY_ME = 'ONLY_ME',
    GADGET_ADMIN = 'GADGET_ADMIN'
}


